import {
  IDetectedBarcode,
  IScannerClassNames,
  IScannerComponents,
  IScannerStyles,
  Scanner
} from '@yudiel/react-qr-scanner'
import { ReactNode } from 'react'
import Finder from './components/Finder/Finder'

interface QrScannerProps {
  onScan: (detectedCodes: IDetectedBarcode[]) => void
  onError?: (error: unknown) => void
  constraints?: MediaTrackConstraints
  formats?: BarcodeFormat[]
  paused?: boolean
  children?: ReactNode
  components?: IScannerComponents
  styles?: IScannerStyles
  classNames?: IScannerClassNames
  scanDelay?: number
  allowMultiple?: boolean
  sound?: boolean | string
  color?: string
}

const QrCodeScanner = ({
  onScan,
  onError,
  constraints = {
    facingMode: 'environment',
    aspectRatio: 1,
    width: { ideal: 1920 },
    height: { ideal: 1080 }
  },
  formats = ['qr_code', 'rm_qr_code', 'micro_qr_code'],
  paused,
  children,
  components,
  styles,
  classNames,
  scanDelay,
  allowMultiple,
  sound,
  color = '#006bff'
}: QrScannerProps) => {
  return (
    <div
      id='qr-scanner'
      style={{
        width: '100%',
        height: 'calc(100% - 40px)',
        margin: '0 auto'
      }}
    >
      <Scanner
        onScan={onScan}
        onError={onError}
        constraints={constraints}
        formats={formats}
        paused={paused}
        components={{ ...components, finder: false }}
        styles={styles}
        classNames={classNames}
        scanDelay={scanDelay}
        allowMultiple={allowMultiple}
        sound={sound}
      >
        {children}
      </Scanner>
      <Finder borderColor={color} />
    </div>
  )
}

export default QrCodeScanner
